import merge from 'lodash/merge';
//
import { button } from './components/button';
import { typography } from './components/typography';
import { buttonGroup } from './components/button-group';
import { textField } from './components/textfield';
import { slider } from './components/slider';
import { radio } from './components/radio';
import { select } from './components/select';
import { card } from './components/card';
import { dialog } from './components/dialog';
import { dataGrid } from './components/data-grid';
import { tabs } from './components/tabs';
import { switches } from './components/switch';
import { menu } from './components/menu';
import { chip } from './components/chip';
import { pagination } from './components/pagination';
import { paper } from './components/paper';
import { accordion } from './components/accordion';
// ----------------------------------------------------------------------
export function componentsOverrides(theme) {
    const components = merge(button(theme), typography(theme), buttonGroup(theme), textField(theme), slider(theme), radio(theme), select(theme), card(theme), dialog(theme), dataGrid(theme), tabs(theme), switches(theme), menu(theme), chip(theme), pagination(theme), paper(theme), accordion(theme));
    return components;
}
